import React from 'react';
import { motion } from 'framer-motion';
import { FaJava, FaPython, FaNodeJs, FaReact, FaDocker, FaAws, FaDatabase, FaLinux, FaWindows, FaApple } from 'react-icons/fa';
import { SiCplusplus, SiGo, SiHtml5, SiCss3, SiTerraform, SiKubernetes, SiMysql, SiPostgresql, SiMongodb, SiJenkins, SiSpring, SiRedis } from 'react-icons/si';

const skillCategories = [
  {
    title: "Programming Languages",
    items: [
      { name: "Java", icon: <FaJava size={40} color="#F89820" /> },
      { name: "Python", icon: <FaPython size={40} color="#4B8BBE" /> },
      { name: "C/C++", icon: <SiCplusplus size={40} color="#00599C" /> },
      { name: "Go", icon: <SiGo size={40} color="#00ADD8" /> },
      { name: "HTML", icon: <SiHtml5 size={40} color="#E34F26" /> },
      { name: "CSS", icon: <SiCss3 size={40} color="#1572B6" /> },
      { name: "JavaScript", icon: <FaReact size={40} color="#F7DF1E" /> },
    ],
  },
  {
    title: "Frameworks & Tools",
    items: [
      { name: "Spring Boot", icon: <SiSpring size={40} color="#6DB33F" /> },
      { name: "React", icon: <FaReact size={40} color="#61DAFB" /> },
      { name: "Node.js", icon: <FaNodeJs size={40} color="#68A063" /> },
      { name: "Docker", icon: <FaDocker size={40} color="#2496ED" /> },
      { name: "Kubernetes", icon: <SiKubernetes size={40} color="#326CE5" /> },
      { name: "Terraform", icon: <SiTerraform size={40} color="#623CE4" /> },
      { name: "Jenkins", icon: <SiJenkins size={40} color="#D24939" /> },
    ],
  },
  {
    title: "Cloud Services",
    items: [
      { name: "AWS", icon: <FaAws size={40} color="#FF9900" /> },
      { name: "Microsoft Azure", icon: <FaDatabase size={40} color="#0078D7" /> },
      { name: "Oracle Cloud", icon: <FaDatabase size={40} color="#F80000" /> },
    ],
  },
  {
    title: "Database",
    items: [
      { name: "MySQL", icon: <SiMysql size={40} color="#4479A1" /> },
      { name: "PostgreSQL", icon: <SiPostgresql size={40} color="#336791" /> },
      { name: "MongoDB", icon: <SiMongodb size={40} color="#4DB33D" /> },
      { name: "Redis", icon: <SiRedis size={40} color="#DC382D" /> },
    ],
  },
  {
    title: "Operating Systems",
    items: [
      { name: "Linux", icon: <FaLinux size={40} color="#FCC624" /> },
      { name: "Windows", icon: <FaWindows size={40} color="#00A4EF" /> },
      { name: "MacOS", icon: <FaApple size={40} color="#A2AAAD" /> },
    ],
  },
  {
    title: "Certifications",
    items: [
      { name: "Oracle Cloud AI Professional", icon: <FaAws size={40} color="#FF9900" /> },
    ],
  },
];

const Skills = () => {
  return (
    <motion.div
      className="skills-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        padding: '4rem 2rem',
        background: 'linear-gradient(to bottom, #ffffff, #f3f4f7)',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
      }}
    >
      <h2 style={{ fontSize: '2.5rem', marginBottom: '2rem', color: '#333', fontWeight: '700' }}>Skills</h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '30px',
          justifyItems: 'center',
        }}
      >
        {skillCategories.map((category, index) => (
          <motion.div
            key={index}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
            style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
              width: '100%',
              maxWidth: '300px',
            }}
          >
            <h3 style={{ fontSize: '1.5rem', color: '#4dd0e1', marginBottom: '1.5rem' }}>
              {category.title}
            </h3>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '15px',
              }}
            >
              {category.items.map((skill, skillIndex) => (
                <motion.div
                  key={skillIndex}
                  whileHover={{ scale: 1.15 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    margin: '0.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                  }}
                >
                  {skill.icon}
                  <p style={{ fontSize: '1rem', color: '#555', fontWeight: '500' }}>{skill.name}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Skills;
